import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';

import RowButtons from './../../components/button/RowButtons';

import RowChangeButton from './../../components/button/RowChangeButton';
import RowDeleteButton from './../../components/button/RowDeleteButton';
import ListTable from './../../components/form/ListTable';
import ListHeader from 'components/form/ListHeader';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;
 
export const TransactionGroupList = ({})  => {
  const [list, setList] = useState([]);  
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);

  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();
  
  const loadList = async () =>{    
    const data = await apiGetCall(BASE_URL + '/admin/transactionkeygroup/summary/');
    if (isResultOk(data, setListError, true)){
      setList(data);
    }    
    setListLoading(false);
  }

  useEffect(() => {
    loadList();
  }, []);


  const onDeleteClick = async (transactionGroupID) => {
    setIsPageLoading(true);
    const data = await apiPostCall(BASE_URL + '/admin/transactionkeygroup/remove', {itemID : transactionGroupID});    
    if (isResultOk(data, setCheckErrorItems)){      
      await loadList();
    }
    setIsPageLoading(false);    
  }


  return (    
    <div>      
      <ListHeader title={t("Færslulyklahópar")}>
        {t("Viðvörun, breytingar á færslulyklahópum getur haft mikil áhrif á virkni kerfisins svo sem niðurstöður og bréf.")}
      </ListHeader>
      <div className="text-right"><Link to="/admin/transactiongroups/edit?new=true" className="no-print button gray-light icon-plus pointer-edit text-14">{t("Stofna færslulyklahóp")}</Link></div>
      <ListTable
          error = {listError}
          isLoading = {listLoading}
          list = {list}
          colsettings = {['20%', '', '']}
          headers = {[
            t("Númer"),
            t("Færslulyklahópur"),
            ""
          ]}
          columns = {[
            (item => (<span>{item.groupKey}</span>)),
            (item => (<span>{item.name}</span>)),
            (item) => (<RowButtons>
                        <RowDeleteButton onClick={() => onDeleteClick(item.transactionGroupID)}/>
                        <RowChangeButton link={"/admin/transactiongroups/edit?transactiongroupid=" + item.transactionGroupID}/>                    
                      </RowButtons>),
          ]}

      />
  </div>
  );
};
